import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Signup() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSignup(e) {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          emailRedirectTo: window.location.origin + '/dashboard'
        }
      })

      if (error) {
        throw error
      }

      if (data?.session) {
        console.log('[SIGNUP] Success with immediate session, redirecting to dashboard...')
        navigate('/dashboard', { replace: true })
      } else if (data?.user && !data?.session) {
        console.log('[SIGNUP] User created, waiting for email confirmation')
        setError('Please check your email to confirm your account.')
        setLoading(false)
      }
    } catch (error) {
      console.error('[SIGNUP] Error:', error)
      setError(error.message || 'Signup failed. Please try again.')
      setLoading(false)
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div className="card" style={{ maxWidth: '450px', width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ fontSize: '36px', marginBottom: '14px', textAlign: 'center', fontWeight: '800', color: '#98FB98', textShadow: '0 0 15px rgba(152, 251, 152, 0.8)', fontFamily: 'VT323, monospace', letterSpacing: '2px' }}>
            &gt; AgencySniper
          </h1>
          <h2 style={{ fontSize: '28px', marginBottom: '14px', textAlign: 'center', fontWeight: '700', color: '#98FB98', textShadow: '0 0 12px rgba(152, 251, 152, 0.7)', fontFamily: 'VT323, monospace', letterSpacing: '2px' }}>
            &gt; INITIALIZE ACCESS
          </h2>
          <p style={{ textAlign: 'center', color: 'rgba(144, 238, 144, 0.85)', marginBottom: '24px', fontSize: '16px', lineHeight: '1.6', textShadow: '0 0 5px rgba(144, 238, 144, 0.3)' }}>
            Request system credentials for AgencySniper operations
          </p>
        </div>

        <form onSubmit={handleSignup}>
          <label className="label">Email Address</label>
          <input
            type="email"
            className="input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="you@example.com"
          />

          <label className="label">Password</label>
          <input
            type="password"
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="••••••••"
            minLength="6"
          />
          <p style={{ fontSize: '13px', color: 'rgba(144, 238, 144, 0.65)', margin: '8px 0 0 0', textShadow: '0 0 3px rgba(144, 238, 144, 0.3)' }}>
            Minimum 6 characters required
          </p>

          {error && <div className="error">{error}</div>}

          <button
            type="submit"
            className="btn"
            disabled={loading}
            style={{ width: '100%', marginTop: '24px' }}
          >
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '28px', fontSize: '15px', color: 'rgba(144, 238, 144, 0.8)', textShadow: '0 0 3px rgba(144, 238, 144, 0.3)' }}>
          Already initialized?{' '}
          <span
            onClick={() => navigate('/login')}
            style={{ color: '#90EE90', cursor: 'pointer', fontWeight: '700', textDecoration: 'underline', textDecorationColor: 'rgba(144, 238, 144, 0.4)', textShadow: '0 0 8px rgba(144, 238, 144, 0.6)' }}
          >
            Access system
          </span>
        </p>

        <p style={{ textAlign: 'center', marginTop: '20px' }}>
          <span
            onClick={() => navigate('/')}
            style={{ color: 'rgba(144, 238, 144, 0.7)', cursor: 'pointer', fontSize: '15px', textShadow: '0 0 3px rgba(144, 238, 144, 0.3)', fontWeight: '500' }}
          >
            ← Return to main
          </span>
        </p>
      </div>
    </div>
  )
}
